import { Button, Table } from "antd";
import React from "react";

const RolesTable = (props: any) => {
  const roleColumns = [
    {
      title: "",
      dataIndex: "",
      key: "",
    },
    {
      title: <span>Role Name</span>,
      dataIndex: "name",
      key: "id",
      width: "70%",
    },
    {
      title: <span>Permissions</span>,
      dataIndex: "id",
      key: "id",
    },
  ];

  return (
    <div>
      <div className="MenuConfig-rowBox">
        <div className="MenuConfig-txt1">Available Roles</div>
        <div style={{ flex: 1 }} />
        <div>
          <Button size="small">Add new + </Button>
        </div>
      </div>
      <Table
        size="small"
        bordered
        dataSource={[]}
        columns={roleColumns}
        rowKey={(data: any) => data?.id}
        pagination={false}
        loading={props?.loading}
      />
    </div>
  );
};

export default RolesTable;
